import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'
import {Container} from '../../modules/components'

export enum FinancialRoutesEnum {
    DatatablePayments = '/financeiro/pagamentos',
    ShowPayment = '/financeiro/pagamentos/:id',
}

export default function FinancialRouter() {
    const DatatablePayments = lazy(() => import('../../pages/financial/payments/DatatablePayments'))
    const ShowPayment = lazy(() => import('../../pages/financial/payments/ShowPayment'))

    return (
        <Container loading={false}>
            <Switch>
                <Route path={FinancialRoutesEnum.ShowPayment} component={ShowPayment} />
                <Route path={FinancialRoutesEnum.DatatablePayments} component={DatatablePayments} />
            </Switch>
        </Container>
    )
}
